<template>
  <div class="oil-list-container">
    <!-- 面包屑导航 - 美化 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="custom-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>加油站列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主卡片 - 圆润现代风格 -->
    <el-card class="modern-card" shadow="never">
      <!-- 搜索与操作栏 -->
      <div class="search-bar">
        <el-form
          size="medium"
          :inline="true"
          :model="searchForm"
          :rules="searchRules"
          ref="searchForRef"
          label-width="auto"
          class="search-form"
        >
          <el-form-item>
            <el-input v-model="searchForm.name" placeholder="所属省份" clearable prefix-icon="el-icon-location"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.name" placeholder="店铺名称" clearable prefix-icon="el-icon-shop"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.name" placeholder="编号" clearable prefix-icon="el-icon-document"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.name" placeholder="类型" clearable prefix-icon="el-icon-menu"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.grade_id"
              placeholder="请选择类别"
              clearable
              prefix-icon="el-icon-star-off"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="success" size="medium" @click="searchSubmit()" class="search-btn">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="addData" class="add-btn">新增加油站</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 - 无边框圆润风格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        size="medium"
        :header-cell-style="headerCellStyle"
        :row-style="{ height: '60px' }"
        class="modern-table"
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>

        <el-table-column label="名称" width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="link-text">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="编码" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="code-text">{{ scope.row.sn }}</span>
          </template>
        </el-table-column>
        <el-table-column label="分类" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.category ? scope.row.category.name : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.cont_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系电话" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="phone-text">{{ scope.row.telephone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属区域" width="220" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.province ? scope.row.province.region_name : '' }}</span>
            <span>{{ scope.row.city ? scope.row.city.region_name : '' }}</span>
            <span>{{ scope.row.district ? scope.row.district.region_name : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="业务员提成比例%" width="140" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <span class="rate-value">{{ scope.row.business_rate | removeExtraZeros }}</span>
          </template>
        </el-table-column>
        <el-table-column label="抽成比例%" width="110" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <span class="rate-value">{{ scope.row.rate | removeExtraZeros }}</span>
          </template>
        </el-table-column>
        <el-table-column label="地址" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.address }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_auth === 1 ? 'success' : (scope.row.is_auth === 2 ? 'warning' : 'info')" size="small" effect="light">
              {{ scope.row.is_auth == 0 ? '待审核' : (scope.row.is_auth == 1 ? '已审核' : '驳回') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="商户号" width="220" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.paysourceparams" class="merchant-info">
              <div><span class="label">提现商户：</span><span class="value">{{ scope.row.paysourceparams.cusid }}</span></div>
              <div><span class="label">手续费商户：</span><span class="value">{{ scope.row.paysourceparams.service_cusid }}</span></div>
            </div>
            <span v-else class="empty-text">未配置</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="140" align="center">
          <template slot-scope="scope">
            <el-dropdown trigger="click" size="medium" @command="handleCommand($event, scope.row)">
              <el-button type="primary" size="small" plain class="action-btn">
                更多操作 <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="auth">审核</el-dropdown-item>
                <el-dropdown-item command="info">查看</el-dropdown-item>
                <el-dropdown-item command="edit">修改</el-dropdown-item>
                <el-dropdown-item command="file">添加资料</el-dropdown-item>
                <el-dropdown-item command="user">增加管理员</el-dropdown-item>
                <el-dropdown-item command="pay">编辑支付账号</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 - 现代风格 -->
      <div class="pagination-wrapper">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="modern-pagination"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 审核弹窗 - 圆润风格 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="480px" class="modern-dialog" center>
      <el-form :model="form" :rules="rules" ref="form" label-width="80px" size="medium">
        <el-form-item label="加油站" prop="name">
          <el-input v-model="form.name" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="审核状态" prop="is_auth">
          <el-select v-model="form.is_auth" placeholder="请选择审核状态" style="width: 100%">
            <el-option
              v-for="item in authList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="reset_dialogForm('form')">取消</el-button>
        <el-button size="medium" type="primary" @click="submitForm('form')">确定</el-button>
      </div>
    </el-dialog>

    <!-- 子组件 -->
    <eFileList
      :formData="formData1"
      :visible="visible1"
      :title="title1"
      :closeForm="closeForm1"
    />
    <eShopUserForm
      :formData="formData2"
      :visible="visible2"
      :title="title2"
      :closeForm="closeForm2"
    />
    <ePaySourceParamsForm
      :formData="formData3"
      :visible="visible3"
      :title="title3"
      :closeForm="closeForm3"
    />
  </div>
</template>

<script>
import eFileList from "./components/eFileList.vue";
import eShopUserForm from "./components/eShopUserForm.vue";
import ePaySourceParamsForm from "./components/ePaySourceParamsForm.vue";
import moment from 'moment';

export default {
  name: "oilList",
  components: {
    eFileList,
    eShopUserForm,
    ePaySourceParamsForm
  },
  data() {
    return {
      authList: [
        { id: 0, name: '待审核' },
        { id: 1, name: '已审核' },
        { id: 2, name: '驳回' }
      ],
      formData1: {},
      visible1: false,
      title1: '',
      formData2: {},
      visible2: false,
      title2: '',
      formData3: {},
      visible3: false,
      title3: '',
      gradeList: [],
      searchForm: {
        name: "",
        cate_id: 13,
        grade_id: ''
      },
      searchRules: {
        name: [{ required: false, message: "请输入文章标题", trigger: "blur" }],
      },
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      showType: '',
      roleList: [],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 3, max: 15, message: "长度在 3 到 15 个字符", trigger: "blur" }
        ],
        is_auth: [{ required: true, message: '请选择审核状态', trigger: 'change' }]
      },
      dialogFormVisible: false,
      title: '审核加油站',
      form: {
        name: '',
        id: '',
        is_auth: '',
      },
    };
  },
  created() {
    this.DataList();
    this.departData();
  },
  filters: {
    dateFormat(add_time) {
      if (add_time == undefined) return "";
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
    },
    statusFilter(status) {
      const map = { 0: "待审核", 1: "已审核", 2: "已出单", 3: "已完成", 4: "取保", 5: "退单" };
      return map[status] || "";
    },
    removeExtraZeros(num) {
      if (!isNaN(num) && num != null) {
        return String(num).replace(/\.?0+$/, '');
      }
      return '';
    }
  },
  methods: {
    // 表格表头样式
    headerCellStyle() {
      return {
        backgroundColor: '#F8F9FC',
        color: '#1E2A3A',
        fontWeight: 600,
        fontSize: '14px',
        borderBottom: '1px solid #EDEFF2'
      };
    },
    // 操作下拉命令
    handleCommand(command, row) {
      switch (command) {
        case 'auth': this.goAuth(row); break;
        case 'info': this.goInfo(row); break;
        case 'edit': this.goEdit(row); break;
        case 'file': this.goFile(row); break;
        case 'user': this.goUser(row); break;
        case 'pay': this.goPaySourceParams(row); break;
      }
    },
    goUser(row) {
      this.formData2 = { ...row, shop_id: row.id, role_id: 32 };
      this.title2 = row.name + " 添加管理员";
      this.visible2 = true;
    },
    closeForm2() {
      this.title2 = "";
      this.visible2 = false;
    },
    goPaySourceParams(row) {
      this.formData3 = { type_id: 2, item: row, shop_id: row.id };
      this.title3 = row.name + "：编辑支付商户号";
      this.visible3 = true;
    },
    closeForm3() {
      this.title3 = "";
      this.pageNum = 1;
      this.tableLoadData = [];
      this.DataList();
      this.visible3 = false;
    },
    goAuth(row) {
      this.form = { id: row.id, name: row.name, is_auth: row.is_auth };
      this.dialogFormVisible = true;
    },
    goFile(row) {
      this.visible1 = true;
      this.formData1 = { shop_id: row.id };
      this.title1 = "图片资料";
    },
    closeForm1() {
      this.title1 = "";
      this.visible1 = false;
    },
    goInfo(row) {
      this.$router.replace({ path: '/shopInfo', query: { id: row.id } });
    },
    goEdit(row) {
      this.$router.replace({ path: '/oilForm', query: { id: row.id } });
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    DataList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        cate_id: 13,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.searchForm
      };
      this.$axios.shopByShopListP(param).then(res => {
        if (res.code == 200) {
          this.tableLoadData = res.data.data;
          this.total = res.data.total;
        }
      }).catch(error => {
        console.log(error);
      });
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.DataList();
    },
    handleCurrentChange(newPage) {
      this.pageNum = newPage;
      this.DataList();
    },
    departData() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
      };
      this.$axios.findTree(param).then(res => {
        if (res.code == 200) {
          this.rightslist = res.data.data;
        }
      }).catch(error => {
        console.log(error);
      });
    },
    addData() {
      this.$router.push('/oilForm');
    },
    reset_dialogForm(formName) {
      this.dialogFormVisible = false;
      this.$nextTick(() => {
        this.$refs[formName] && this.$refs[formName].resetFields();
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.form.id) {
          const param = {
            id: this.form.id,
            is_auth: this.form.is_auth,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
          };
          this.$axios.shopAuth(param).then(res => {
            if (res.code == 200) {
              this.DataList();
              this.$message.success(res.msg);
              this.dialogFormVisible = false;
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    searchSubmit() {
      this.pageNum = 1;
      this.DataList();
    },
  },
};
</script>

<style scoped>
/* 整体容器背景 */
.oil-list-container {
  background-color: #F5F7FA;
  min-height: 100vh;
  padding: 20px 24px 40px;
}

/* 自定义面包屑 */
.custom-breadcrumb {
  margin-bottom: 20px;
  font-size: 14px;
}
.custom-breadcrumb >>> .el-breadcrumb__inner {
  color: #6C7A8E;
  font-weight: normal;
}
.custom-breadcrumb >>> .el-breadcrumb__inner a:hover {
  color: #1677FF;
}
.custom-breadcrumb >>> .el-breadcrumb__separator {
  color: #C0C4CC;
}

/* 主卡片 - 圆角大阴影 */
.modern-card {
  border-radius: 24px;
  border: none;
  background-color: #FFFFFF;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.01);
  transition: box-shadow 0.2s;
}
.modern-card >>> .el-card__body {
  padding: 24px 28px 32px;
}

/* 搜索栏美化 */
.search-bar {
  margin-bottom: 28px;
  background: #F8F9FC;
  padding: 16px 20px;
  border-radius: 20px;
}
.search-form >>> .el-form-item {
  margin-bottom: 8px;
  margin-right: 16px;
}
.search-form >>> .el-input__inner,
.search-form >>> .el-select .el-input__inner {
  border-radius: 40px;
  border: 1px solid #E4E7ED;
  transition: all 0.2s;
  background-color: #FFFFFF;
  height: 40px;
  line-height: 40px;
}
.search-form >>> .el-input__inner:focus,
.search-form >>> .el-select .el-input__inner:focus {
  border-color: #1677FF;
  box-shadow: 0 0 0 2px rgba(22,119,255,0.1);
}
.search-btn,
.add-btn {
  border-radius: 40px;
  padding: 9px 24px;
  font-weight: 500;
  transition: transform 0.1s, box-shadow 0.2s;
}
.search-btn {
  background-color: #1AB86A;
  border-color: #1AB86A;
}
.search-btn:hover {
  background-color: #0F9A56;
  border-color: #0F9A56;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(26,184,106,0.3);
}
.add-btn {
  background-color: #1677FF;
  border-color: #1677FF;
}
.add-btn:hover {
  background-color: #0958D9;
  border-color: #0958D9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(22,119,255,0.3);
}

/* 表格现代风格 */
.modern-table {
  border-radius: 20px;
  overflow: hidden;
}
.modern-table >>> .el-table__header-wrapper th {
  background-color: #F8F9FC !important;
  font-weight: 600;
  color: #1E2A3A;
  border-bottom: 1px solid #EDEFF2;
}
.modern-table >>> .el-table__row td {
  border-bottom: 1px solid #F0F2F5;
}
.modern-table >>> .el-table__row:hover td {
  background-color: #FAFBFF !important;
}
.link-text {
  color: #1677FF;
  font-weight: 500;
  cursor: pointer;
}
.code-text {
  font-family: monospace;
  color: #8C9AA8;
  font-size: 13px;
}
.phone-text {
  color: #2C3E50;
  font-weight: 500;
}
.rate-value {
  font-weight: 600;
  color: #1AB86A;
}
.merchant-info {
  font-size: 12px;
  line-height: 1.6;
}
.merchant-info .label {
  color: #8C9AA8;
}
.merchant-info .value {
  color: #2C3E50;
  font-family: monospace;
}
.empty-text {
  color: #A3AFC1;
  font-style: italic;
}

/* 操作按钮 */
.action-btn {
  border-radius: 30px;
  border: 1px solid #D9DEE4;
  background: #FFFFFF;
  color: #5A6878;
  padding: 6px 16px;
}
.action-btn:hover {
  border-color: #1677FF;
  color: #1677FF;
  background-color: #F0F7FF;
}

/* 分页组件美化 */
.pagination-wrapper {
  margin-top: 28px;
  display: flex;
  justify-content: flex-end;
}
.modern-pagination >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1677FF;
  border-radius: 12px;
}
.modern-pagination >>> .el-pagination.is-background .el-pager li {
  border-radius: 12px;
  margin: 0 4px;
  font-weight: 500;
}
.modern-pagination >>> .el-pagination .btn-prev,
.modern-pagination >>> .el-pagination .btn-next {
  border-radius: 12px;
}
.modern-pagination >>> .el-select .el-input__inner {
  border-radius: 20px;
}

/* 弹窗圆润风格 */
.modern-dialog >>> .el-dialog {
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}
.modern-dialog >>> .el-dialog__header {
  background: linear-gradient(135deg, #F8F9FC 0%, #FFFFFF 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #EDEFF2;
}
.modern-dialog >>> .el-dialog__title {
  font-weight: 600;
  font-size: 18px;
  color: #1E2A3A;
}
.modern-dialog >>> .el-dialog__body {
  padding: 28px 24px;
}
.modern-dialog >>> .el-dialog__footer {
  padding: 16px 24px;
  border-top: 1px solid #F0F2F5;
}
.modern-dialog >>> .el-button {
  border-radius: 40px;
  padding: 8px 24px;
}
.modern-dialog >>> .el-button--primary {
  background-color: #1677FF;
  border-color: #1677FF;
}
.modern-dialog >>> .el-button--primary:hover {
  background-color: #0958D9;
  border-color: #0958D9;
}

/* 标签美化 */
.el-tag--light {
  border-radius: 30px;
  padding: 0 12px;
  font-weight: 500;
}
</style>